module.exports = __webpack_public_path__ + "media/images/vp/icon.document.white-ed0c6fa6a65b054808258d9360a1571c.svg";